"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORT_MAIN_ROUTE = 'help';
exports.SUPPORT_TERMS_AND_CONTITIONS = 'terms-and-conditions';
